// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".count-badge{border-radius:50%;background:#09f;color:#fff;width:16px;height:16px}.count-badge div{width:1ch;font-size:.5em;line-height:.8em;flex-shrink:0;text-align:center;margin-right:1px;margin-top:1px}", ""]);
// Exports
module.exports = exports;
